<template>
  <div class="pages privacy">
    <div class="container">
      <h3><a id="PRO_0"></a>“画世界PRO”隐私政策</h3>
      <p>
        <strong
          >更新日期：2026年8月20日<br />
          生效日期：2026年8月20日</strong
        >
      </p>
      <p>
        杭州摸鲸科技有限公司（简称“我们”）作为画世界PRO的运营者，我们非常重视保护您的隐私和个人信息，我们将按照法律法规的规定，保护您的个人信息及隐私安全。我们希望通过本《隐私政策》向您清晰地介绍您在使用我们的产品或服务时，我们如何处理您的个人信息，以及我们为您提供的管理、保护这些信息的方式。<br />
        <strong
          >【特别提示】在使用画世界PRO之前，请务必仔细阅读本政策，为实现您选择使用的功能、服务，或为遵守法律法规的要求，我们会处理相关信息。除实现画世界PRO基本功能、服务所需的信息，和根据法律法规要求所必需的信息之外，您可以拒绝我们处理其他信息，但这可能导致我们无法提供对应功能、服务。我们将在隐私政策中逐项说明相关情况，有关您个人信息权益的重要条款已用加粗形式提示，请特别关注。</strong
        ><br />
        除本政策外，在特定场景下，我们将以及时告知的方式（包括但不限于更新本政策、页面提示、弹窗）另行向您详细说明对应信息的处理目的、方式、范围等规则，并在征得您的授权同意后处理。
      </p>
      <p>
        <strong>本政策将帮助您了解以下内容</strong><br />
        <strong
          >1我们如何收集和使用个人信息<br />
          2我们如何存储个人信息<br />
          3数据使用过程中涉及的合作方以及转移、公开个人信息<br />
          4我们如何保护个人信息安全<br />
          5我们如何处理未成年人的个人信息<br />
          6您的权利<br />
          7适用范围<br />
          8其他<br />
          9如何联系我们</strong
        >
      </p>
      <p>
        <strong>1我们如何收集和使用个人信息</strong><br />
        <strong>1.1 帐号服务</strong><br />
        <strong>1.1.1 注册、登录</strong><br />
        您可以通过画世界账号登录画世界PRO，当您通过画世界账号登录时，我们将收集您的账号昵称、头像，用于您登录账号时验证您的身份。<br />
        当您注册、登录画世界PRO以及使用相关服务时，为了帮您顺利完成注册/登录流程，您需要向我们提供您的<strong>手机号码</strong>、手机登录密码信息。收集手机号码是履行国家法律法规关于网络实名制（真实身份信息认证）要求的必要信息，如果您拒绝提供手机号码用于注册、登录，我们可能无法为您提供信息发布图文和上传素材功能。<br />
        您可以通过手机号码创建帐号，可以完善相关的网络身份识别信息（头像、昵称、密码、地区）。<br />
        一键登录：基于我们与通信运营商的合作，当您使用“一键登录”功能时，经过您的同意，运营商会将您的手机号码发送给我们，便于我们为您提供免于密码或动态验证码核验的快捷登录服务。如果你不希望使用“一键登录”功能，可以通过其他方式注册、登录画世界PRO。<br />
        如果您忘记了您画世界PRO的登录方式，可以使用找回密码功能。为保障您帐号的安全，我们需要您填写相关信息以进行验证，必要时可能通过真实身份信息验证等方式验证您的身份。<br />
        <strong>1.1.2 账号资料维护</strong><br />
        为便于您在画世界PRO内对个人资料进行查看与维护，您可自主选择填写您的性别、昵称、头像、地区。如您未填写，不影响您使用我们产品或服务的基本功能。<br />
        您在上传/更换头像时，我们会请求您的<strong>相机、相册</strong>权限，并在经您授权后收集您上传/更换的图片信息。<br />
        <strong>1.1.3画世界PRO统一账号和关联产品</strong><br />
        画世界PRO各关联产品均使用统一的画世界帐号服务，包括不限于画世界、画世界PRO、画世界PC版、熊猫绘画以及画世界官方网站。
        您可以使用画世界帐号便捷地登录、使用画世界关联产品，和对应产品的服务或功能。如您在任一款产品中对账号信息（包括账号密码、手机号码）进行修改，该修改将会自动同步至您的统一账号。您理解并同意，如您在任一款产品中实施账户注销，将可能会影响您使用其他产品。<br />
        <strong>1.1.4 实名认证</strong><br />
        为了满足网络实名制要求、确保用户身份真实性、实现反欺诈等风险控制、保障系统和服务安全，在您找回账号或使用集市消费超出上限金额进行实名认证时，需要您提供<strong>真实身份信息</strong>（<strong>真实姓名、身份证件号码或人脸信息，根据实际情况可能有所不同</strong>）以完成实名认证。<br />
        在实名认证的过程中，需要由提供认证服务的第三方认证机构核验您的<strong>真实身份信息</strong>。这些信息仅供完成实名认证使用，不会用作其他目的。您可以拒绝提供此认证，将无法使用必须实名认证才可使用的功能或相关服务。但不影响您使用其他功能与服务。<br />
        <strong>1.2 绘画工具</strong><br />
        本应用运行时会读取媒体影音数据用于编辑照片、音频和显示草稿文件。<br />
        您在使用画世界PRO查看草稿箱内容、创建草稿、上传草稿、导出作品、笔刷保存时，我们会申请您授权<strong>存储</strong>权限，用以记录您的绘画数据、笔刷数据和读取草稿数据，如果您拒绝将无法使用对应功能。<br />
        您在绘画创作中、使用图片创建画布、临摹参考和导入图片功能时，我们会申请您授权<strong>相机、相册</strong>权限，用于拍照和访问相册。如您拒绝授权，将无法使用对应功能，但不影响您使用画世界PRO的其他功能。您可以在设备的设置功能中选择关闭部分或全部权限。在不同设备中，上述权限的开启和关闭方式可能有所不同。<br />
        您在制作动画添加音频选择录音时，我们会申请您授权<strong>麦克风</strong>权限，用以录入声音数据，如果您拒绝，将无法使用录音功能。<br />
        在接入特定数位板和手写笔时，我们会读取蓝牙（Bluetooth）信息，为您提供更好的绘画输入设备支持。客户端在使用时会读取写入剪切板，用于实现复制颜色功能。<br />
        <strong>1.3 下单与支付</strong><br />
        当您在画世界PRO中购买商品或服务时（包含开通/续费VIP），在支付过程中，我们可能会收集您的第三方支付账号。为便于协助您顺利完成交易、查询订单信息，以及向您提供客户服务和保障您的交易安全，我们需要根据商品或服务类型收集如下部分或全部的个人信息：包括<strong>订单编号、交易金额、下单时间、订单状态、支付方式、支付账号、支付状态</strong>。这些信息是支付功能所必需的信息，拒绝提供将导致您无法使用该功能，但不影响其他功能的正常使用。<br />
        <strong>1.4 运营与安全运行</strong><br />
        我们致力于为您提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。为了维护相关产品或服务的正常稳定运行，保护您或其他用户或公众的安全及合法利益，我们会收集如下必要信息：<br />
        1.4.1
        为了解决不同设备的兼容问题，我们会获取您的设备信息（包括：硬件型号、设备分辨率、操作系统版本号）、软件版本号、CPU序列号，确保您在不同型号的设备上都可以获得最优的使用体验。<br />
        1.4.2
        为了保障帐号安全和防止异常活动，我们会收集您的可变设备标识符（OAID、GAID）、传感器信息、应用来源、任务列表数据、手机BootID、安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、总体安装使用情况、服务日志。<br />
        1.4.3
        为了提升服务质量和运行稳定性，我们会收集网络相关信息（WLAN接入点（SSID，BSSID）、IP地址、网络接入方式、状态、参数、信号强度、DHCP信息）、应用崩溃情况、性能数据，用于优化和提升产品的流畅性和稳定性。<br />
        1.4.4在使用分享和一键登录时，我们会收集粗略的定位信息，用于精细化运营和设备安全检测。<br />
        <strong>1.5Cookie等同类技术的使用</strong><br />
        Cookie
        和设备信息标识等同类技术是互联网中普遍使用的技术。当您使用画世界PRO及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie
        或匿名标识符，以收集、标识您访问、使用本产品时的信息。我们承诺，不会将Cookie
        用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie
        和同类技术主要为了实现以下功能或服务：<br />
        保障产品与服务的安全、高效运转：我们可能会设置认证与保障安全性的Cookie
        或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。<br />
        帮助您获得更轻松的访问体验：使用此类技术可以帮助您省去重复填写个人信息、输入搜索内容的步骤和流程（示例：记录搜索、表单填写）。<br />
        <strong>1.6 服务内容的变更</strong><br />
        请您了解，随着我们业务的发展，可能会调整画世界PRO提供的产品或服务。如调整变化后的产品或服务所处理个人信息的目的、方式和范围发生变化的，我们会通过推送消息、邮件、弹窗、蓝点提示等方式再次向您告知，并求征得您的同意。<br />
        <strong>1.7 广告（含个性化广告）</strong><br />
        我们可能与广告的服务商、供应商和其他合作伙伴以及与我们达成推广合作的合作伙伴（合称“合作方”）共享分析去标识化的设备信息（IDFA、OAID），广告数据（曝光、点击、转化数据），设备信息（设备型号、系统语言、屏幕高宽、屏幕方向），应用及使用数据（应用包名、操作日志），连接的<strong>WIFI</strong>。<strong>请您放心这些信息难以或无法与您的真实身份相关联。这些信息将帮助我们分析、衡量广告、推广和相关服务的有效性</strong>。<br />
        当您使用创新广告交互功能（摇动、扭动、扭转设备）时，我们会调用设备的陀螺仪、加速度、重力传感器以识别判断您的设备状态。<br />
        若您不想接受个性化广告服务，您可以在我们的产品务的相关功能设置页面开启/关闭个性化广告。个性化广告设置路径为：“我的-通用设置-个性化广告管理”。若您选择关闭，您看到的广告数量不会减少，但本产品将不再向您展示个性化广告，您看到的广告将可能与您的偏好相关度降低。<br />
        <strong>1.8依法豁免征得同意处理个人信息</strong><br />
        请您理解，在下列情形中，根据法律法规，我们处理您的个人信息无需征得您的授权同意。<br />
        a) 根据您的要求订立或履行合同所必需；<br />
        b)
        为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；<br />
        c)
        为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；<br />
        d)
        为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；<br />
        e)
        在合理的范围内处理您自行公开的个人信息，或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）；<br />
        f) 法律法规规定的其他情形。
      </p>
      <p>
        <strong>2我们如何存储个人信息</strong><br />
        <strong>2.1信息存储的地点</strong><br />
        <strong
          >我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循国家相关规定，征求您的同意</strong
        >。<br />
        <strong>2.2存储期限</strong><br />
        我们仅在为提供画世界PRO及服务之目的所必需的期间内保留您的个人信息，例如，您发布的图文、音视频等信息，在您未撤回、删除或未注销账号期间，我们会保留相关信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。<br />
        <strong>3数据使用过程中涉及的合作方以及转移、公开个人信息</strong><br />
        <strong>3.1数据使用过程中涉及的合作方</strong><br />
        <strong>3.1.1基本原则</strong><br />
        我们与合作方合作过程中，将遵守以下原则：<br />
        a) 合法原则：涉及数据处理活动的，应当遵守合法原则。<br />
        b)
        正当与最小必要原则：数据使用必须具有正当目的，且应以达成目的必要为限。<br />
        c) 安全审慎原则：
        我们将审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。<br />
        |
      </p>
      <p>
        <strong>3.1.3 委托处理</strong><br />
        <strong
          >对于委托处理个人信息的场景，我们会与受托合作方根据法律规定签署相关处理协议，并对其个人信息使用活动进行监督。</strong
        ><br />
        <strong>3.1.4共同处理</strong><br />
        <strong
          >对于共同处理个人信息的场景，我们会与合作方根据法律规定签署相关协议并约定各自的权利和义务，确保在使用相关个人信息的过程中遵守法律的相关规定、保护数据安全。若具体功能和场景中涉及由我们的关联方、第三方提供服务，则合作方范围包括我们的关联方与第三方。</strong
        ><br />
        <strong>3.1.4.1实现广告相关的信息共享</strong><br />
        为实现程序化广告推送，我们可能会与广告合作伙伴（包括广告主和其他广告服务提供商）共享去标识化或匿名化处理后的信息，以帮助其在不识别您个人身份的前提下提升广告的有效触达率。未经您授权，我们不会将您的个人身份信息（即可以识别您身份的信息，例如<strong>姓名或手机号码</strong>）与广告合作伙伴共享。<br />
        <strong>3.2活动参与</strong><br />
        当您选择参加我们举办的营销活动时，经过您的同意，我们与合作方可能需要使用您的<strong>姓名、通信地址、联系方式、银行账号</strong>信息，以便合作方向您兑现活动奖励。当您参与我们和关联方共同举办的营销活动时，可能会在多个参与活动的移动应用程序（简称“活动平台”）之间同步您参与活动的帐号（含标识符）、参与成绩、进度、收益等信息，以保障您在活动中获得完整的服务体验。<br />
        <strong>3.3 实现安全与统计分析</strong><br />
        a)
        保障使用安全：我们非常重视产品和服务的安全性，为保障画世界PRO用户的正当合法权益免受不法侵害，我们的合作方可能会使用必要的设备、帐号及日志信息。<br />
        b）分析产品情况：为分析画世界PRO的产品和服务的稳定性，提供分析服务的合作方可能需要使用服务情况（崩溃、闪退记录）、设备标识信息、应用总体安装使用情况等信息。<br />
        c)
        学术科研：为提升相关领域的科研能力，促进科技发展水平，我们在确保数据安全与目的正当的前提下，可能会与合作的科研院所、高校等机构使用去标识化或匿名化的数据。<br />
        <strong>3.4 运营主体变更</strong><br />
        随着业务的持续发展，我们将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所载明的安全标准要求继受方保护您的个人信息，继受方变更原先的处理目的、处理方式的，我们将要求继受方重新征得您的授权同意。<br />
        <strong>3.5停止运营</strong><br />
        如果我们停止运营产品或服务，将及时停止继续收集您的个人信息。我们会逐一送达通知或以公告的形式向您发送停止运营的告知，并对我们所持有的与已关停的产品或服务相关的个人信息进行删除或匿名化处理。<br />
        <strong>3.6 依法豁免征得您的授权同意的情形</strong><br />
        请您理解，在下列情形中，根据法律法规及国家标准，合作方使用，或我们转移、公开您的个人信息无需征得您的授权同意：<br />
        a) 根据您的要求订立或履行合同所必需；<br />
        b)
        为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；<br />
        c)
        为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；<br />
        d)
        为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；<br />
        e)
        在合理的范围内处理您自行公开的个人信息，或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）；<br />
        f) 法律法规规定的其他情形。
      </p>
      <p>
        <strong>4我们如何保护个人信息安全</strong><br />
        <strong
          >4.1我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。</strong
        ><br />
        4.2我们会使用不低于行业同行的加密技术、匿名化处理等合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。<br />
        4.3我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。<br />
        4.4尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。<br />
        4.5我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止该等安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以推送通知、邮件、信函、短信等形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。<br />
        4.6我们谨此特别提醒您，本隐私政策提供的个人信息保护措施仅适用于画世界PRO软件及相关服务。一旦您离开画世界PRO及相关服务，浏览或使用其他网站、服务及内容资源，我们没有能力及义务保护您在画世界PRO软件及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于画世界PRO的链接或引导。
      </p>
      <p>
        <strong>5我们如何处理未成年人的个人信息</strong><br />
        我们非常重视对未成年人个人信息的保护。若您是未成年人，在使用画世界Pro及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。若您是未成年人的监护人，在使用画世界Pro及相关服务前，应为您的被监护人阅读并同意本隐私政策，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本隐私政策公示的联系方式与我们联系。<br />
        我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、共享或披露未成年人的个人信息。您可以通过阅读<a
          href="https://staticpro.mjing.art/hsj/agreement/#/mojing/hsjpro/privacy/children"
          target="_blank"
          >《未成年人隐私保护》</a
        >了解更多信息。
      </p>
      <p>
        <strong>6您的权利</strong><br />
        我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的访问、修改（更新或更正）、删除以及撤回授权同意的权利，以使您有能力保障您的隐私和安全。<br />
        <strong>6.1访问、更正、删除您的个人信息</strong><br />
        您可以通过以下方式管理您的信息：<br />
        当您完成画世界PRO的账号注册、登录并进行合理和必要的身份验证后，您可以查阅、修改、删除您提交给画世界PRO软件及相关服务的个人信息（包括修改昵称、头像）。<br />
        <strong>6.2管理、撤回授权您的信息</strong><br />
        您可以在设备的设置功能中开启或关闭<strong>摄像头、相册、存储</strong>权限，改变授权范围或撤回您的授权。<br />
        请您理解，特定的业务功能和服务将需要您的信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供授权所对应的功能和服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响公司此前基于您的授权而开展的个人信息处理。<br />
        <strong>6.3注销您的账号</strong><br />
        您可以在客户端应用程序中点击左上方【我的】进入个人中心，点击【账号与安全】-【注销账号】注销您的账号。在您注销账号前，我们将验证您的个人身份、安全状态、设备信息等。您知悉并理解，注销账号的行为是不可逆的行为，当您注销账号后，我们将删除有关您账号的一切信息或对相关信息进行匿名化处理，但法律法规另有规定的除外。<br />
        <strong>6.4投诉举报</strong><br />
        您可以按照我们公示的制度进行投诉或举报。如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，您可以在客户端应用程序中点击左上方【我的】进入个人中心，点击【问题反馈】与我们联系，我们核查后会在15日内反馈您的投诉与举报。<br />
        <strong>6.5访问隐私政策</strong><br />
        您可以在注册页面，或者在登录个人账号【我的】—【关于】—【隐私政策】查看本隐私政策的全部内容。
      </p>
      <p>
        <strong>7适用范围</strong><br />
        本隐私权政策适用于由杭州摸鲸科技有限公司及其关联方提供的所有服务，包括画世界PRO客户端，不适用于有单独的隐私权政策且未纳入本隐私权政策的第三方产品或服务。<br />
        当您在使用我们的服务过程中接触到由第三方独立提供的产品/服务（包括但不限于广告服务）时，该等服务的隐私保护将遵循其运营者另行制定的隐私政策。我们建议您在使用前仔细阅读第三方提供的相关协议及政策文件，以便更好地了解其个人信息处理规则。<br />
        在您主动选择使用第三方服务时，我们可能会基于服务必需原则依法依规共享必要信息。我们始终秉持审慎态度选择合作方，并对其信息安全能力进行必要审核。您可通过本政策&quot;第三方SDK清单&quot;章节查询具体合作方名录。<br />
        本隐私政策中所述的画世界PRO及相关服务有可能会根据您所使用的手机型号、系统版本、软件应用程序版本等因素而有所不同。最终的产品和服务以您所使用的画世界PRO软件及相关服务为准。<br />
        如对本隐私政策内容有任何疑问、意见或建议，您可通过登录画世界PRO客户端内的【我的】-【问题反馈】页面与我们联系。
      </p>
      <p>
        <strong>8其他</strong><br />
        本“隐私政策”中的标题仅为方便及阅读而设，并不影响本《隐私政策》中任何规定的含义或解释。<br />
        《隐私政策》是我们统一适用的一般性隐私条款，其中所规定的用户权利及信息安全保障措施均适用于画世界PRO用户。
      </p>
      <p>
        <strong>9如何联系我们</strong><br />
        杭州摸鲸科技有限公司将按照本政策保护您的信息。如您有关于网络信息安全的投诉和举报，或您对本政策、您的信息的相关事宜有任何问题、意见或建议，以及有关本政策或画世界PRO隐私措施的问题请与我们的协调人联系（画世界PRO客户端左上角【我的】-【问题反馈】）。<br />
        一般情况下，我们将在收到您的问题、意见或建议，并验证您的用户身份后的15天内予以回复。
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "MojingHsjProPrivacy",
};
</script>
<style lang="scss">
.privacy {
  .container {
    font-size: 14px;

    h1 {
      font-size: 24px;
    }

    .top__desc {
      font-size: 14px;
      text-indent: 2em;
      line-height: 2;
    }

    h6.subtitle {
      font-size: 14px;
      font-weight: normal;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .third-url-list {
      > a {
        display: block;
      }
    }

    li {
      > h2 {
        display: inline;
        font-size: 14px;
        font-weight: bold;

        + ol {
          margin-top: 15px;
        }
      }

      p {
        margin-top: 1em;
        margin-bottom: 0;
      }
    }
  }

  p {
    margin-top: 1em;
    margin-bottom: 0;
    line-height: 2;
  }

  a {
    // display: block;
    word-break: break-all;
    color: #1989fa;
    text-decoration: none;
  }

  table {
    color: #646466;
    font-size: 14px;
    border-spacing: 0;
    border: 1px solid #ebeef5;
    table-layout: fixed;
    width: 100%;
    line-height: normal;
    text-indent: initial;
    text-align: center;

    tr {
      > th {
        padding: 8px 10px;
        border-bottom: 1px solid #d9d9db;

        &:first-child,
        &:last-child {
          width: 80px;
        }
      }
    }

    th,
    td {
      box-sizing: border-box;
      font-weight: normal;
      border-bottom: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
    }

    td {
      padding: 10px 8px;
      vertical-align: middle;
      text-align: center;
    }
  }
}
</style>
